import logo from './../img/logo.svg'
import { useState, useRef, useEffect } from 'react';
import Config from '../Config';
import { Messages } from './Messages';
import ComboBox from '../helpers/ComboBox';
import { InputText } from '../helpers/InputText';
import { AutoPay } from '../plugins/autoPay/AutoPay';

 
export function ClientSaldo(props)
{   
    const [data, setData] = useState({
        client:props.userData.client,
        tempCode: null
    });

    const [komunikat,setKomunikat] = useState('');
 
    var tmpData = data;
   
    const loginTempUser = () => {
        
        let sendData = ({
            email:props.userData.email,
            client:props.userData.client,
            tempCode:data.tempCode,
            expertId:props.userData.expertId
        })

        fetch(Config.url+'/rest_public,loginTempUser',{
            method:'POST',
            body: JSON.stringify(sendData), 
            mode:'cors',
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.apiKey
            }
        })
        .then(res => res.json() )
        .then(res => {
            
            if(res.status=='ok')
            {
                props.setUser(
                    res.userType,
                    res.apiKey,
                    props.userData.chat_id,
                    props.userData.crypt,
                    res.saldo,
                    props.userData.email,
                    props.userData.expertId,
                    data.client,
                    props.userData.orderId,
                    props.userData.stawka_klient
                ); 

                setKomunikat('');
                return <div></div>;
            }
            
            if(res.status=='error')
            {
                setKomunikat(<span className='msg_error'>Wprowadzono błędny kod tymczasowy</span>);

                return <div></div>;
            }
            
            
        })
        .catch(err => {
            console.log("Err " + err);
        });

        return false;
    }

    const changeValueListner = (name,value,status) =>{
        
        tmpData[name] = value;
        tmpData[name+"_status"] = status; 

        //localStorage.setItem('name', value );
        setKomunikat('');
        setData(  JSON.parse(JSON.stringify(tmpData)) );    
    }
    
    
    if(props.userData.client!='' && data.client!=props.userData.client)
    {
        setData({
            client:props.userData.client,
            tempCode: null    
        })
        return <div></div>
    }
    
    
    
    if(props.userData.apiKey=='' &&  data.tempCode!=null && data.tempCode_status=='valid' && komunikat=='')
    {
        loginTempUser();
    }
    
    
    
    if(props.userData.email!='' && props.userData.apiKey.length<5)
    {       
            
            return (
                <div className='mw-forms__field'>
                    <div class="mw-forms__field">
                        <label class="mw-forms__label saldo_opis" >Na podany przez Ciebie adres e-mail przyjdzie wiadomość z kodem tymczasowym, wprowadź go do poniższego pola:</label>
                        <InputText type='number' required='true' placeholder="Twój 6 cyfrowy kod tymczasowy" length='6' name='tempCode' className='mw-forms__input' changeValue={changeValueListner} value={data.tempCode}/>
                        
                    </div>
                    {komunikat}    
                </div>
            )
            
    }
    

    var minut_1 ='';
    var minut_2 ='';
    var minut_3 ='';
    var max_min ='';

    if(props.userData.stawka_klient!=0)
    {   
        if(props.userData.saldo==0 || props.userData.stawka_klient==0 || props.userData.stawka_klient==undefined) 
            var max_min = ' (0 min)';
        else
            var max_min = ' ('+Math.floor(props.userData.saldo/props.userData.stawka_klient)+'min)';

        
        minut_1=<span className='podpisy' >{Math.floor(50/props.userData.stawka_klient)} min</span> ;
        minut_2=<span className='podpisy' >{Math.floor(100/props.userData.stawka_klient)} min</span> ;
        minut_3=<span className='podpisy' >{Math.floor(150/props.userData.stawka_klient)} min</span> ;
    }


    if(props.userData.apiKey.length>5)
    {
        return (
            <div>
                <div className='mw-expert-card-saldo'>
                    <div className="mw-expert-card__header">
                        Saldo Twojego kodu {data.tempCode} to: {props.userData.saldo} zł{max_min}. 
                    </div>
                </div>
                <div className='mw-expert-card__payments'>
                    <label class="mw-forms__label">Możesz również doładować konto</label>
                        <div class="mw-forms__payment-radio">

                            <AutoPay userData={props.userData} data={data} amount='50.00' />
                            <AutoPay userData={props.userData} data={data} amount='100.00'/>
                            <AutoPay userData={props.userData} data={data} amount='150.00' />
                        </div>   

                        <div class="mw-forms__payment-radio">
                            
                        {minut_1}        
                        {minut_2}        
                        {minut_3}        
                            
                        
                            
                            
                        </div> 
                </div>
                        <br></br>
                    

            </div>
            
        )
    }

    

    return (
        <div>
            
        </div>
    )
}
